// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__-g_p4","footer":"ChangeClinic_footer__3enP5"};